import type { FloatingPosition } from '@mantine/core';
import clsx from 'clsx';

import { FormLabel } from '../formlabel/FormLabel';
import { TextWithTooltip } from '../tooltip/TextWithTooltip';

import inputStyles from '../input/input.module.scss';
import styles from './readOnlyInput.module.scss';

export type ReadOnlyInputProps = {
  label?: string;
  tableLayout?: boolean;
  tooltipPosition?: FloatingPosition;
  value?: string;
  hasError?: boolean;
};

export const ReadOnlyInput = ({
  label,
  tableLayout,
  tooltipPosition,
  value,
  hasError,
}: ReadOnlyInputProps) => {
  const classToApply =
    hasError === true
      ? styles['validation-error']
      : hasError === false
        ? styles['validation-success']
        : undefined;
  return (
    <div className={clsx({ [inputStyles['root--table-layout']]: tableLayout })}>
      <FormLabel label={label} className={styles['label']} />
      <div
        className={clsx({
          [styles['value--table-layout']]: tableLayout,
        })}
      >
        <TextWithTooltip
          tooltipProps={{
            position: tooltipPosition,
            usePortal: false,
          }}
          textProps={{
            lineClamp: tableLayout ? 2 : 1,
          }}
        >
          <span className={classToApply}>{value}</span>
        </TextWithTooltip>
      </div>
    </div>
  );
};
